import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  AcuerdoIndirectoDTO,
  DocumControllerService,
  DocumentoModel,
} from 'api-rest';
import { DocumentsDialogComponent } from '../documents-dialog/documents-dialog.component';
import swal from 'sweetalert2';
import { SpinnerService } from '../../services/spinner.service';
import { DownloadService } from '../../services/download.service';
import { SnackbarService } from '../../services/snackbar.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DatePipe } from '@angular/common';
const ENTITY_TYPE_ACUERDO_INDIRECTO = 'acuerdo_indirecto';
const ESTADO_BAJA = 6;

@Component({
  selector: 'managers-agreements-detail-documents',
  templateUrl: './detail-documents.component.html',
  styleUrls: ['./detail-documents.component.scss']
})
export class DetailDocumentsComponent implements OnChanges {
  @Input() acuerdoIndirectoInfo!: AcuerdoIndirectoDTO;
  @Input() canUpload = false;
  @Input() canDelete = false;
  @Output() public refrescarAdheridoEvent = new EventEmitter<any>();

  containerAcuerdosGestores: string = this.environment.documentContainerAcuerdosGestores;

  documentos: DocumentoModel[] = [];
  gridArray: any = [];
  headArray: any = [
    {
      Head: 'Tipo',
      FieldName: 'tipoDocumento',
      Attribute: 'descripcion',
    },
    {
      Head: 'Descripción',
      FieldName: 'descripcion',
      Tooltip: true,
      Maxtext: 30,
    },
    {
      Head: 'Fecha Creación',
      FieldName: 'fechaCreacion',
      Tooltip: true,
      renderValue: (item: any) =>
        this.datePipe.transform(item.fechaCreacion, 'dd/MM/yyyy'),
    },
    {
      Head: 'Fecha Ult. Modificación',
      FieldName: 'fechaModificacion',
      renderValue: (item: any) =>
      this.datePipe.transform(item.fechaModificacion, 'dd/MM/yyyy'),
    },
    {
      Head: 'Modificado por',
      FieldName: 'usuarioModificacion',
      Tooltip: true,
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'donwload',
          icon: 'download',
          toolTip: 'Descargar',
          show: { params: 'canAccessDonwload', accion: 'donwload' },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
      ],
      width: '8',
      permanent: true,
    },
  ];

  constructor(
    @Inject('environment') private environment: any,
    private documControllerSrv: DocumControllerService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    private downloadSrv: DownloadService,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.acuerdoIndirectoInfo?.id) {
      this.cargarDocumentos();
    }
  }

  cargarDocumentos() {
    this.spinnerSrv.loadingShow();
    this.documControllerSrv
      .listDocs(ENTITY_TYPE_ACUERDO_INDIRECTO, this.acuerdoIndirectoInfo.id!)
      .subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.documentos = response;
          this.gridArray = this.canAccessAll(response ?? []);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          console.log(err);
        },
      });
  }

  descargar(element: any) {
    this.spinnerSrv.loadingShow();
    this.documControllerSrv.downloadDoc(element.id).subscribe({
      next: (response: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadSrv.downloadBlob(response, element.nombre);
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al descargar el documento',
          'error'
        );
      },
    });
  }

  eliminarDocumento(element: any) {
    this.spinnerSrv.loadingShow();
    this.documControllerSrv.deleteDoc(element.id).subscribe({
      next: (response) => {
        this.snackBarSrv.showSnackBar(
          'Se ha eliminado correctamente el documento',
          'success'
        );
        this.spinnerSrv.loadingHide();
        this.cargarDocumentos();
      },
      error: (err) => {
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al eliminar el documento',
          'error'
        );
        this.spinnerSrv.loadingHide();
        console.log(err);
      },
    });
  }

  canAccessNuevoDoc(): boolean {
      return this.canUpload && this.acuerdoIndirectoInfo?.estado?.id !== ESTADO_BAJA;
  }

  canAccessExportar(): boolean {
    return this.authService.can('acuerdo-indirecto-documentos', 'access');
  }

  action(item: any) {
    if (item.nameButton == 'donwload') {
      this.descargar(item);
    } else if (item.nameButton == 'delete') {
      this.confirmacionEliminar(item);
    }
  }

  confirmacionEliminar(element?: any): void {
    swal
      .fire({
        text: '¿Desea eliminar Documento?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.eliminarDocumento(element);
        }
      });
  }

//revisar authservice
  canAccessAll(list: any) {
    const descargarView = true;
    //  this.authService.can('acuerdo-indirecto-documentos', 'update');
    const deleteView = this.canDelete;
    //  this.authService.can('acuerdo-indirecto-documentos', 'delete');
    const listPermission = list.map((objeto: any) => {
      if (objeto.descripcion === 'null') {
        objeto.descripcion = '';
      }
      return {
        ...objeto,
        canAccessDonwload: descargarView,
        canAccessDelete: deleteView,
      };
    });

    return listPermission;
  }

  abrirNuevoDocumento() {
    const dialogRef = this.dialog.open(DocumentsDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        acuerdoIndirectoInfo: this.acuerdoIndirectoInfo,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.cargarDocumentos();
        this.refrescarAdheridoEvent.emit(true);
      }
    });
  }
}
